// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__5vshY","errorLogs":"EditorFooter_errorLogs__uk09e"};